import { ActionType } from 'deox';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Dashboard } from 'services/api';

import {
  getDashboardInfo,
  getMachines,
  activateMachine,
  deactivateMachine,
  renameMachine,
} from './actions';
import { processRequestError } from 'modules/error/actions';
import { setNotification } from 'modules/app/actions';

import texts from './texts';
import { t } from 'utils';

function* getDashboardInfoSaga() {
  try {
    const { data } = yield call(Dashboard.getDashboardInfo);
    yield put(getDashboardInfo.success(data));
  } catch (error) {
    yield put(processRequestError({ error, failAction: getDashboardInfo.fail }));
  }
}

function* getMachinesSaga() {
  try {
    const { data } = yield call(Dashboard.getMachines);
    yield put(getMachines.success(data));
  } catch (error) {
    yield put(processRequestError({ error, failAction: getMachines.fail }));
  }
}

function* activateMachineSaga({
  payload,
}: ActionType<typeof activateMachine.request>): SagaIterator {
  try {
    yield call(Dashboard.activateMachine, payload);
    yield put(getMachines.request());
    yield put(activateMachine.success());
    // @ts-ignore
    yield put(setNotification(true, t(texts.dashboard.activetedCamera)));
  } catch (error) {
    yield put(processRequestError({ error, failAction: activateMachine.fail }));
  }
}

function* deactivateMachineSaga({
  payload,
}: ActionType<typeof deactivateMachine.request>): SagaIterator {
  try {
    yield call(Dashboard.deactivateMachine, payload);
    yield put(getMachines.request());
    yield put(deactivateMachine.success());
    // @ts-ignore
    yield put(setNotification(true, t(texts.dashboard.deactivatedCamera)));
  } catch (error) {
    yield put(processRequestError({ error, failAction: deactivateMachine.fail }));
  }
}

function* renameMachineSaga({ payload }: ActionType<typeof renameMachine.request>): SagaIterator {
  try {
    const { id, nickname } = payload;
    yield call(Dashboard.renameMachine, { id, nickname });
    yield put(getMachines.request());
    yield put(renameMachine.success());
    // @ts-ignore
    yield put(setNotification(true, t(texts.dashboard.cahgedNickname)));
  } catch (error) {
    yield put(processRequestError({ error, failAction: renameMachine.fail }));
  }
}

export function* watchDashboard(): SagaIterator {
  yield takeLatest(getDashboardInfo.request, getDashboardInfoSaga);
  yield takeLatest(getMachines.request, getMachinesSaga);
  yield takeLatest(activateMachine.request, activateMachineSaga);
  yield takeLatest(deactivateMachine.request, deactivateMachineSaga);
  yield takeLatest(renameMachine.request, renameMachineSaga);
}
